module.exports = __webpack_public_path__ + "img/icon-startup-light-gray-dark.55c994a3.svg";